export const hrJobManagementApi = {
    heading:[
        {
            head:"Role"
        },
        {
            head:"Department"
        },
        {
            head:"Level"
        },
        {
            head:"Salary Range"
        },
        {
            head:"Employment Type"
        },
        {
            head:"Work Place"
        },
        {
            head:"Experience Required"
        },
        {
            head:"Description"
        },       
        {
            head:"Action"
        },
    ],
    data:[
        {
            role:"Junior Developer",
            department:"IT",
            level:"Senior",
            salaryrange:"15000-25000",
            employementtype:"Permanent",
            workplace:"Dhaka",
            experienceRequired:"1 year",
            description:"I am very hard working",
            action:{
                edit:"./assets/images/dashboards/adminDashboard/HR/icons/editicon.png",
                cross:"./assets/images/dashboards/adminDashboard/HR/icons/crossicon.png"
            }
        },
        {
            role:"UI/UX Designer",
            department:"IT",
            level:"Senior",
            salaryrange:"15000-25000",
            employementtype:"Permanent",
            workplace:"Dhaka",
            experienceRequired:"1 year",
            description:"I am very hard working",
            action:{
                edit:"./assets/images/dashboards/adminDashboard/HR/icons/editicon.png",
                cross:"./assets/images/dashboards/adminDashboard/HR/icons/crossicon.png"
            }
        },
       
      
    ]
}